(ns practitest.frontend.milestone.readiness-index.events
  (:require [practitest.frontend.common.re-frame :as rf-common]
            [practitest.frontend.routing.backend-routes :as broutes]
            [malli.util :as mu]))

(defn db-path [milestone]
  [:milestones (:id milestone)])

(defn url-for [_db {:keys [id project-id]}]
  (broutes/get-url "milestones#readiness_index"
                   {:p_id project-id :id id}))

(defn transform [_evt {:keys [rrqi ccs ecs rdrs executed-per-day]}]
  #:metrics
  {:rrqi             rrqi
   :ccs              ccs
   :ecs              ecs
   :rdrs             rdrs
   :executed-per-day executed-per-day})

(def Metrics
  (mu/optional-keys
   [:map
    [:metrics/rrqi [:maybe number?]]
    [:metrics/ccs  [:maybe number?]]
    [:metrics/ecs  [:maybe number?]]
    [:metrics/rdrs [:maybe number?]]
    [:metrics/executed-per-day
     [:maybe
      [:vector
       [:map
        [:date  inst?]
        [:value number?]]]]]]))

(def load-readiness-index
  {:evt       ::fetch
   :db-path   db-path
   :url-for   url-for
   :schema    Metrics
   :transform transform})

(rf-common/reg-load-data-events load-readiness-index)
